import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

import { CurrentlySufferingAndFollowUpQuestions } from "./CurrentlySufferingAndFollowUpQuestions";

// eslint-disable-next-line max-len
const HealthSurveillanceRespiratorySectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.Respiratory}
        >
            <h4>Preparing for spirometry</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DoYouSmoke),
                    getQuestionConfig(props.questionConfigs, questionIds.HowManySmokePerDay)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ExSmoker),
                    getQuestionConfig(props.questionConfigs, questionIds.ExSmokerWhenQuitAndHowManySmokePerDay)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.AnyMedicationAsthmaOtherRespiratoryConditions),
                    getQuestionConfig(props.questionConfigs, questionIds.AnyMedicationAsthmaOtherRespiratoryConditionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DrinkAlcohol),
                    getQuestionConfig(props.questionConfigs, questionIds.DrinkAlcoholNumberOfUnitsPerWeek)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Exercise),
                    getQuestionConfig(props.questionConfigs, questionIds.ExerciseHoursPerWeek)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Are you currently suffering from any of the following?</h4>
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingAsthma),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingAsthmaSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingAsthmaSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingAsthmaFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBronchitis),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBronchitisSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBronchitisSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBronchitisFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingTuberculosis),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingTuberculosisSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingTuberculosisSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingTuberculosisFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingDryCough),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingDryCoughSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingDryCoughSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingDryCoughFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestTightness),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestTightnessSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestTightnessSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestTightnessFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringSorenessWateringOfEyes),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringSorenessWateringOfEyesFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWorkRelatedBreatingProblems),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWorkRelatedBreatingProblemsSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWorkRelatedBreatingProblemsSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWorkRelatedBreatingProblemsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingCancer),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingCancerSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingCancerSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingCancerFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestInjury),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestInjurySymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestInjurySymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingChestInjuryFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBreathlessness),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBreathlessnessSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBreathlessnessSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingBreathlessnessFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWheezing),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWheezingSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWheezingSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingWheezingFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {CurrentlySufferingAndFollowUpQuestions({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringBlockedRunningNose),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringBlockedRunningNoseSymptomsResultOfWork),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringBlockedRunningNoseSymptomsResultsOfHome),
                    getQuestionConfig(props.questionConfigs, questionIds.CurrentlySufferingRecurringBlockedRunningNoseFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceRespiratorySection = connect(makeMapStateToQuestionnaireSectionProps(sections.Respiratory.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceRespiratorySectionUnconnected);
